import React from 'react';
import {Link} from "react-router";
import dollars from '../../dollar-format';
import {executeQuery} from "../../requests/executeQuery";
import {AGENT_PIPELINE_BUCKET_PROPERTIES} from '../../consts/queries';
import '../PipelineDetails/PipelineDetails.scss';

// The /agent-pipeline rows that link here, keyed by the slug in the URL.
export const buckets = {
    outside: {name: 'Outside Agent', holders: 'Outside Agent'},
    prior: {name: 'Prior Agents', holders: 'Prior Agent'},
    unassigned: {name: 'Unassigned'},
};

// The pipeline's column groups, in its order. Closed is this year's closings only.
const statuses = [
    {status: 'Active', name: 'Active Listings', priceLabel: 'List Price'},
    {status: 'In Negotiation', name: 'In Negotiation', priceLabel: 'Price'},
    {status: 'Under Contract', name: 'Under Contract', priceLabel: 'Price'},
    {status: 'Closed', name: 'Closed - YTD', priceLabel: 'Sold Price'},
];

const percent = value => `${(value * 100).toFixed(2)}%`;

export default class AgentPipelineBucket extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: [],
            loading: true,
        };
    }

    componentDidMount() {
        this.fetch();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.bucket !== this.props.params.bucket) {
            this.fetch();
        }
    }

    fetch() {
        this.setState({loading: true});
        executeQuery({queryName: AGENT_PIPELINE_BUCKET_PROPERTIES, params: {BUCKET: this.props.params.bucket}}).then(res => {
            this.setState({
                rows: res && res.success && Array.isArray(res.data) ? res.data : [],
                loading: false,
            });
        });
    }

    renderTable({status, name, priceLabel}, bucket) {
        const rows = this.state.rows.filter(row => row.STATUS === status);
        const total = key => rows.reduce((sum, row) => sum + parseFloat(row[key] || 0), 0);

        const cols = [
            {label: 'Property Name', value: row => <Link to={{pathname: `${arc.path.base}property/${row.ARCIMEDES_ROW_ID}`}}>{row.NAME || row.ARCIMEDES_ROW_ID}</Link>},
            {label: 'City', value: row => row.CITY},
            {label: 'State', value: row => row.STATE},
            {label: priceLabel, value: row => dollars(row.PRICE || 0, true)},
            {label: 'Fee Percentage', value: row => `${parseFloat(row.SELLER_FEE_PERCENTAGE || 0).toFixed(2)}%`},
            {label: `% of Deal - ${bucket.name}`, value: row => percent(parseFloat(row.SHARE || 0)), total: () => total('SHARE').toFixed(2)},
            {label: `${priceLabel} - ${bucket.name}`, value: row => dollars(row.BUCKET_PRICE || 0, true), total: () => dollars(total('BUCKET_PRICE'), true)},
            {label: `Gross Fee - ${bucket.name}`, value: row => dollars(row.BUCKET_FEE || 0, true), total: () => dollars(total('BUCKET_FEE'), true)},
        ];
        if (bucket.holders) {
            cols.push({label: bucket.holders, value: row => row.HOLDERS || '-'});
        }

        return (
            <React.Fragment key={status}>
                <h4>{name}</h4>
                {
                    rows.length ?
                        <table className='table'>
                            <thead>
                            <tr>
                                {cols.map((col, index) => <th key={col.label} className={`th head border_top agent-head ${index === 0 ? 'border_left' : ''}`}>{col.label}</th>)}
                            </tr>
                            </thead>
                            <tbody>
                            {
                                rows.map(row => (
                                    <tr key={row.ARCIMEDES_ROW_ID}>
                                        {cols.map((col, index) => <td key={col.label} className={`td ${index === 0 ? 'border_left' : ''}`} style={{textAlign: index === 0 ? '' : 'center'}}>{col.value(row)}</td>)}
                                    </tr>
                                ))
                            }
                            </tbody>
                            <tfoot>
                            <tr>
                                {cols.map((col, index) => <th key={col.label} className={`th ${index === 0 ? 'border_left' : ''}`}>{index === 0 ? `Total (${rows.length})` : (col.total ? col.total() : '')}</th>)}
                            </tr>
                            </tfoot>
                        </table>
                        :
                        <div className='no-data-found'>No properties</div>
                }
            </React.Fragment>
        );
    }

    render() {
        const bucket = buckets[this.props.params.bucket];

        if (!bucket) {
            return <div className='agent-details-container'><div className='no-data-found'>Unknown pipeline row</div></div>;
        }

        return (
            <div className='agent-details-container'>
                <Link to={{pathname: `${arc.path.base}agent-pipeline`}}>SUMMIT Agent Pipeline</Link>
                <div className='agent-details'>
                    <h4 className='agent-name-label'>Name:</h4>
                    <h4 className='agent-name'>{bucket.name}</h4>
                </div>
                {
                    this.state.loading ?
                        <div className='no-data-found'>Loading...</div>
                        :
                        statuses.map(status => this.renderTable(status, bucket))
                }
            </div>
        );
    }
}
